import { Visit } from "interface/visit"
import { memoize } from "lodash-es"
import { humanReadable } from "."
import { DEFAULT_PLACEHOLDER } from "./constants"
import { asDate, Dayjs } from "./date"

export const formatVisitStatus = memoize((status: Visit["status"]) =>
	humanReadable(status),
)

export const visitStatusOptions = memoize(
	(allowedStatuses: readonly Visit["status"][]) =>
		allowedStatuses.map((status) => ({
			value: status,
			label: formatVisitStatus(status),
		})),
	(allowedStatuses) => allowedStatuses.join(),
)

export const visitStatusDate = (visit: Visit) => {
	if (visit.status === "CANCELLED") {
		return visit.cancelDate
	}
	if (visit.status === "COMPLETED") {
		return visit.completedDate
	}
	return visit.visitDate
}

export function prettyVisitInterval({
	visitDate,
	visitDurationInMinutes,
}: Visit) {
	if (!visitDate || !visitDurationInMinutes) {
		return DEFAULT_PLACEHOLDER
	}

	const start = asDate(visitDate)

	return `${start.format("hh:mm")} – ${start.add(visitDurationInMinutes, "minute").format("hh:mm A")}`
}

export function clampVisitEnd(visitStart: Dayjs, visitEnd: Dayjs) {
	return (
		visitEnd.isBefore(visitStart.endOf("day"))
			? visitEnd
			: visitEnd.startOf("day").subtract(15, "minute")
	).toISOString()
}
